import React, { Fragment } from 'react';
import { isValue } from '@bluevision/tools';

// handle history code
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const ToggleRender: React.FC<{ visible?: any }> = ({ visible, children }) => (
  <Fragment>{isValue(visible) ? children : null}</Fragment>
);

export default ToggleRender;
